import { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { Link as Linkscroll } from "react-scroll";
import { FiSearch, FiX } from "react-icons/fi";
import VehicleCard from "../VehicleCard";
import useFinanciaciones from "../../config/useFinanciaciones";
import loading from "../../assets/loading.svg";
import FinancingCarousel from "./FinancingCarousel";
import { buildUtmQueryString } from "../../config/whatsappConfig";

const matchesModelSearch = (item, tipoKey, query) => {
  const term = query.trim().toLowerCase();
  if (!term) return true;
  const info = item[tipoKey];
  const modelo = (info?.modelo || "").toLowerCase();
  const version = (info?.version || "").toLowerCase();
  return modelo.includes(term) || version.includes(term);
};

const buildRouteWithUtms = (route) => `${route}${buildUtmQueryString()}`;

const VehicleList = ({ vehicles }) => {
  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [modelSearch, setModelSearch] = useState("");

  const history = useHistory();
  const { tipo } = useParams();

  useEffect(() => {
    if (tipo !== "todos" && tipo !== "convencional" && tipo !== "plan") {
      history.push(buildRouteWithUtms("/todos"));
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const handleTipo = (e) => {
    setTipoSearch(e);
    history.push(buildRouteWithUtms(`/${e}`));
  };

  const filtradosConvencional = vehicles.filter((item) => item.convencional.habilitado === true);
  const filtradosPlan = vehicles.filter((item) => item.plan.habilitado === true);

  const filteredConvencional = filtradosConvencional.filter((item) =>
    matchesModelSearch(item, "convencional", modelSearch),
  );
  const filteredPlan = filtradosPlan.filter((item) => matchesModelSearch(item, "plan", modelSearch));

  const isSearching = Boolean(modelSearch.trim());

  const showConvencional =
    (tipoSearch === "convencional" || tipoSearch === "todos" || isSearching) &&
    (!isSearching || filteredConvencional.length > 0);

  const showPlan = false;

  const noSearchResults = isSearching && filteredConvencional.length === 0 && filteredPlan.length === 0;

  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  return (
    <>
      <div id="scroll-click" className="vehicle-list-toolbar pt-4 pb-4">
        <div className="vehicle-list-toolbar-inner">
          <div className="vehicle-list-toolbar-buttons">
            <Linkscroll
              className={`btn btn-blue m-2 ${tipoSearch === "convencional" && "active"}`}
              onClick={() => handleTipo("convencional")}
              to="scroll-click"
            >
              Venta directa
            </Linkscroll>
          </div>
          <div className="vehicle-list-search">
            <FiSearch aria-hidden="true" />
            <input
              type="search"
              placeholder="Buscar modelo..."
              value={modelSearch}
              onChange={(e) => setModelSearch(e.target.value)}
              aria-label="Buscar modelo"
            />
            {modelSearch ? (
              <button type="button" onClick={() => setModelSearch("")} aria-label="Limpiar búsqueda">
                <FiX />
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {noSearchResults ? <p className="text-center pt-4 pb-5">No se encontraron resultados para tu búsqueda.</p> : null}

      {showConvencional ? (
        <div id="convencional">
          <div className="vehicle-list-section-header">
            <Container>
              <Row>
                <Col>
                  <h2 className="vehicle-list-section-title text-center">
                    ¡Llevate tu vehículo en Montironi por <b>Venta Directa</b>!
                  </h2>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="d-flex">
            {filteredConvencional.length > 0 ? (
              filteredConvencional
                .sort((a, b) => a.convencional.prioridad - b.convencional.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosConvencional}
                      nombreTipo="convencional"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <p className="text-center pt-5 pb-5 w-100">Proximamente más opciones disponibles.</p>
            )}
          </Row>
          <div id="financiaciones" className="financing-section">
            <p className="financing-section-subtitle">Financiá por Venta Directa</p>
            {loadingFinanciaciones ? (
              <Row className="d-flex justify-content-center mb-5">
                <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
              </Row>
            ) : financiaciones && financiaciones.length > 0 ? (
              <FinancingCarousel financiaciones={financiaciones} />
            ) : null}
          </div>
        </div>
      ) : null}

      {showPlan ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          <div className="vehicle-list-section-header">
            <Container>
              <Row>
                <Col>
                  <h2 className="vehicle-list-section-title text-center">
                    ¡Llevate tu <b>Hyundai</b> con Plan de Ahorro!
                  </h2>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="d-flex">
            {filteredPlan.length > 0 ? (
              filteredPlan
                .sort((a, b) => a.plan.prioridad - b.plan.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPlan}
                      nombreTipo="plan"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <p className="text-center pt-5 pb-5 w-100">Proximamente más opciones disponibles.</p>
            )}
          </Row>
        </div>
      ) : null}
    </>
  );
};

export default VehicleList;

